function Star(id, x, y){
    this.id = id;
    this.x = x;
    this.y = y;
    this.r = Math.floor(Math.random()*2)+1;
    var alpha = (Math.floor(Math.random()*10)+1)/10/2;
    this.color = "rgba(255,255,255,"+alpha+")";
}
Star.prototype.draw = function() {
    mpCtx.fillStyle = this.color;
    mpCtx.shadowBlur = this.r * 2;
    mpCtx.beginPath();
    mpCtx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
    mpCtx.closePath();
    mpCtx.fill();
}
Star.prototype.move = function() {
    this.y -= .15;
    if (this.y <= -10) this.y = mpHEIGHT + 10;
    this.draw();
}
Star.prototype.die = function() {
    mpStars[this.id] = null;
    delete mpStars[this.id];
}
function Dot(id, x, y, r) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.r = Math.floor(Math.random()*5)+1;
    this.maxLinks = 2;
    this.speed = .5;
    this.a = .5;
    this.aReduction = .005;
    this.color = "rgba(255,255,255,"+this.a+")";
    this.linkColor = "rgba(255,255,255,"+this.a/4+")";
    this.dir = Math.floor(Math.random()*140)+200;
}
Dot.prototype.draw = function() {
    mpCtx.fillStyle = this.color;
    mpCtx.shadowBlur = this.r * 2;
    mpCtx.beginPath();
    mpCtx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
    mpCtx.closePath();
    mpCtx.fill();
}
Dot.prototype.link = function() {
    if (this.id == 0) return;
    var previousDot1 = getPreviousDot(this.id, 1);
    var previousDot2 = getPreviousDot(this.id, 2);
    var previousDot3 = getPreviousDot(this.id, 3);
    if (!previousDot1) return;
    mpCtx.strokeStyle = this.linkColor;
    mpCtx.moveTo(previousDot1.x, previousDot1.y);
    mpCtx.beginPath();
    mpCtx.lineTo(this.x, this.y);
    if (previousDot2 != false) mpCtx.lineTo(previousDot2.x, previousDot2.y);
    if (previousDot3 != false) mpCtx.lineTo(previousDot3.x, previousDot3.y);
    mpCtx.stroke();
    mpCtx.closePath();
}
function getPreviousDot(id, stepback) {
    if (id == 0 || id - stepback < 0) return false;
    if (typeof mpDots[id - stepback] != "undefined") return mpDots[id - stepback];
    else return false;
}
Dot.prototype.move = function() {
    this.a -= this.aReduction;
    if (this.a <= 0) {
        this.die();
        return
    }
    this.color = "rgba(255,255,255,"+this.a+")";
    this.linkColor = "rgba(255,255,255,"+this.a/4+")";
    this.x = this.x + Math.cos(degToRad(this.dir))*this.speed,
    this.y = this.y + Math.sin(degToRad(this.dir))*this.speed;
    this.draw();
    this.link();
}
Dot.prototype.die = function() {
    mpDots[this.id] = null;
    delete mpDots[this.id];
}
var mpCanvas, mpCtx, mpWIDTH, mpHEIGHT, mpMouseMoving, mpMouseMoveChecker, mpMouseX, mpMouseY, mpStars, mpInitStarsPopulation, mpDots, mpDotsMinDist, mpMaxDistFromCursor;
function parametersInit(){
    mpCanvas  = document.getElementById('mouseParticle');
    mpCtx = mpCanvas.getContext('2d');
    mpMouseMoving = false;
    mpStars = [];
    mpInitStarsPopulation = 80;
    mpDots = [];
    mpDotsMinDist = 2;
    mpMaxDistFromCursor = 50;
}
function setCanvasSize() {
    mpWIDTH = document.documentElement.clientWidth,
    mpHEIGHT = document.documentElement.clientHeight;                      
    mpCanvas.setAttribute("width", mpWIDTH);
    mpCanvas.setAttribute("height", mpHEIGHT);
}
function init() {
    mpCtx.strokeStyle = "white";
    mpCtx.shadowColor = "white";
    for (var i = 0; i < mpInitStarsPopulation; i++) {
        mpStars[i] = new Star(i, Math.floor(Math.random()*mpWIDTH), Math.floor(Math.random()*mpHEIGHT));
    }
    mpCtx.shadowBlur = 0;
    animate();
}
function animate() {
    mpCtx.clearRect(0, 0, mpWIDTH, mpHEIGHT);
    for (var i in mpStars) {
        mpStars[i].move();
    }
    for (var j in mpDots) {
        mpDots[j].move();
    }
    drawIfMouseMoving();
    requestAnimationFrame(animate);
}
function windowEventInit(){
    window.onmousemove = function(e){
        mpMouseMoving = true;
        mpMouseX = e.clientX;
        mpMouseY = e.clientY;
        clearInterval(mpMouseMoveChecker);
        mpMouseMoveChecker = setTimeout(function() {
            mpMouseMoving = false;
        }, 100);
    };
    window.onresize = function(e){
        setCanvasSize();
    };
}
function drawIfMouseMoving(){
    if (!mpMouseMoving) return;
    if (mpDots.length == 0) {
        mpDots[0] = new Dot(0, mpMouseX, mpMouseY);
        mpDots[0].draw();
        return;
    }
    var previousDot = getPreviousDot(mpDots.length, 1);
    var prevX = previousDot.x; 
    var prevY = previousDot.y; 
    var diffX = Math.abs(prevX - mpMouseX);
    var diffY = Math.abs(prevY - mpMouseY);
    if (diffX < mpDotsMinDist || diffY < mpDotsMinDist) return;
    var xVariation = Math.random() > .5 ? -1 : 1;
    xVariation = xVariation*Math.floor(Math.random()*mpMaxDistFromCursor)+1;
    var yVariation = Math.random() > .5 ? -1 : 1;
    yVariation = yVariation*Math.floor(Math.random()*mpMaxDistFromCursor)+1;
    mpDots[mpDots.length] = new Dot(mpDots.length, mpMouseX+xVariation, mpMouseY+yVariation);
    mpDots[mpDots.length-1].draw();
    mpDots[mpDots.length-1].link();
}

function degToRad(deg) {
    return deg * (Math.PI / 180);
}


export const MouseParticle = {
    Star: Star,
    Dot: Dot,
    parametersInit: parametersInit,
    setCanvasSize:setCanvasSize,
    init: init,
    windowEventInit: windowEventInit,
};